import React, {useEffect, useState} from 'react';
import CustomHeader from '../../../components/mazraeKit/headers/homeHeader';
import classNames from 'classnames';
import useGetPromotedAdvertisement from '../../../services/hookService/getPromotedAdvertisement/useGetPromotedAdvertisement';
import DotsLoading from '../../../components/dotsLoading';
import PromotedList from './promotedList';
import StepOne from './stepOne';
import StepTwo from './stepTwo';
import StepThree from './stepThree';

import {useLocation, useParams} from 'react-router-dom';
import {SpanIcon} from '@mazraeapp/react_icon_kit';

const UpgradeAccount = () => {
  const {guid} = useParams();
  const {state} = useLocation();
  const [choosed, setchoosed] = useState<Array<IPromotedAdvertisement>>([]);
  const [stepChoosed, setStepChoosed] = useState('stepOne');
  const [paymentWay, setpaymentWay] = useState<string>();
  const [freePlans, setfreePlans] = useState<Array<IPromotedAdvertisement>>([]);

  const {data, isLoading} = useGetPromotedAdvertisement({guid});
  const handleChoosePlan = (chosedFiled: IPromotedAdvertisement) => {
    const foundItem = choosed.find(item => item.guid === chosedFiled.guid);
    if (foundItem) {
      setchoosed(prev => prev.filter(item => item.guid !== chosedFiled.guid));

      setfreePlans(prev => prev.filter(item => item.guid !== chosedFiled.guid));
    } else {
      setchoosed(prev => [...prev, chosedFiled]);

      if (
        chosedFiled.number_allowed_promotion_plans !== 0 &&
        chosedFiled.promotion_type !== 'sms'
      ) {
        if (freePlans.length < chosedFiled.number_allowed_promotion_plans) {
          setfreePlans(prev => [...prev, chosedFiled]);
        }
      }
    }
  };
  useEffect(() => {
    if (state && data) {
      setchoosed(
        data?.total_package.filter(item =>
          state.selected.some(
            (selectedItem: string) => selectedItem === item.guid,
          ),
        ),
      );
    }
  }, [state, data]);

  return (
    <div className="flex overflow-y-auto w-full h-full flex-col justify-between">
      <CustomHeader
        title="ارتقا آگهی"
        preIcon="icon-nameArrow---Right"
        isActiveRightIcon
        backRoute={state?.cancell_route && `/my-ads`}
      />
      <div className="d-flex w-full flex-col gap-1 h-full overflow-y-scroll px-3 py-4">
        <p className="text-gray-900 tex-md font-Regular">
          با ارتقا آگهی، احتمال بازدید از آگهی شما و برقراری ارتباط با خریداران
          و فروشندگان افزایش می‌یابد.
        </p>

        <p className="flex h-[34px] text-gray-900 text-sm font-Regular rounded-[8px] gap-2 w-full bg-farm-shop-50 border border-farm-shop-500 items-center px-3">
          <span className="">
            <SpanIcon className="icon-nameerror text-[18px] bg-farm-shop-500 text-white rounded-full" />
          </span>
          <span>
            {data?.number_allowed_promotion_plans} ارتقای رایگان از پکیج شما
            باقی مانده است.
          </span>
        </p>
        {isLoading ? (
          <DotsLoading />
        ) : (
          <>
            {data && (
              <PromotedList
                setfreePlans={setfreePlans}
                handleChoosePlan={handleChoosePlan}
                choosed={choosed}
                data={data}
              />
            )}
          </>
        )}
      </div>
      {choosed.length > 0 && (
        <div
          className={classNames(
            'flex w-full fixed rounded-t-[8px] px-2 bg-white bottom-0 gap-2 right-0 left-0 flex-col justify-between py-2 shadow-dropShadow',
          )}
        >
          {stepChoosed === 'stepOne' && (
            <StepOne
              price={choosed.reduce(
                (accumulator, currentValue) =>
                  accumulator +
                  (currentValue.discounted_price
                    ? currentValue.discounted_price
                    : currentValue.price),
                0,
              )}
              setStepChoosed={setStepChoosed}
            />
          )}
          {stepChoosed === 'stepTwo' && (
            <StepTwo
              freePlans={freePlans}
              choosed={choosed}
              setStepChoosed={setStepChoosed}
            />
          )}
          {stepChoosed === 'StepThree' && (
            <StepThree
              freePlans={freePlans}
              type="advertisment"
              paymentType="advertisement"
              choosed={choosed}
              paymentWay={paymentWay}
              setpaymentWay={setpaymentWay}
              setfreePlans={setfreePlans}
              setStepChoosed={setStepChoosed}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default UpgradeAccount;
